import { render } from "./CourseDrawerOverview.vue?vue&type=template&id=c673c35e&scoped=true"
import script from "./CourseDrawerOverview.vue?vue&type=script&lang=js"
export * from "./CourseDrawerOverview.vue?vue&type=script&lang=js"

import "./CourseDrawerOverview.vue?vue&type=style&index=0&id=c673c35e&lang=sass&scoped=true"

import exportComponent from "../../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c673c35e"]])

export default __exports__